(function () {
  'use strict';

  angular
    .module('app.payment-error', [])

    .directive('cartPaymentError', function () {
      return {
        restrict: 'A',
        controllerAs: 'cartCtrl',
        /* @ngInject */
        controller: ["RoutesService", function (RoutesService) {
          var ctrl = this;
          ctrl.backLink = '/' + RoutesService.getUrlByName('CartPayment');
        }]
      };
    });

})();
